import React,{useState} from "react"
import DateUtil from "../../common/dateUtil";
import StatusComp from "../../common/StatusComp";
import CommentComp from "../common/CommentComp";
import { isLevelFourRaymondJames } from "../../common/checkClient";
import ChangeSetDisplayComp from "../common/ChangeSetDisplayComp";

const UserAccountDetailComp = (props) => {
    return (
        <div className="panel-body">
            
            <div className="panel-columns">

                <div className="panel-column">

                    {props.data.status && 
                        <div className="panel-item">
                            <div className="panel-item-label">Status :</div>
                            <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                        </div>
                    }

                    <div className="panel-item">
                        <div className="panel-item-label">Account Number :</div>
                        <div className="panel-item-value">{props.data.accountNumber}</div>
                    </div>
                    <div className="panel-item">
                        <div className="panel-item-label">Account Name :</div>
                        <div className="panel-item-value">{props.data.accountName}</div>
                    </div>

                    <div className="panel-item mb-0-important">
                        <div className="panel-item-label">Beneficiaries :</div>
                        <ul className="panel-item-value">
                            {props.data.beneficiaries.map((item,idx)=>(
                                <li key={idx}>{item}</li>
                                ))}
                        </ul>
                    </div>

                    <div className="panel-item">
                        <div className="panel-item-label">Account Relationship :</div>
                        <div className="panel-item-value">{props.data.accountRelation==='Other'?props.data.otherRelation:props.data.accountRelation}</div>
                    </div>

                    <div className="panel-item">
                        <div className="panel-item-label">Account Registration :</div>
                        <div className="panel-item-value">{props.data.accountRegistration === 'Other'?props.data.otherRegistration:props.data.accountRegistration}</div>
                    </div>

                    <div className="panel-item">
                        <div className="panel-item-label">Account Type :</div>
                        <div className="panel-item-value">{props.data.accountType}</div>
                    </div>

                    <div className="panel-item">
                        <div className="panel-item-label">Open Date :</div>
                        <div className="panel-item-value">{DateUtil.toStrDate(props.data.accountOpenDate)}</div>
                    </div>
                    
                </div>

                <div className="panel-column">

                    <div className="panel-item">
                        <div className="panel-item-label">Financial Institution :</div>
                        <div className="panel-item-value">{props.data.brokerDealerId!=='Other'?props.data.brokerDealerName:props.data.otherBrokerDealer}</div>
                    </div>

                    {props.data.brokerDealerId==='Other'&&
                    <>
                        <div className="panel-item">
                            <div className="panel-item-label">Address :</div>
                            <div className="panel-item-value">{props.data.otherBrokerDealerAddress}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Contact Information :</div>
                            <div className="panel-item-value">{props.data.otherBrokerDealerContact}</div>
                        </div>
                        
                    </>
                    
                    }
                    <div className="panel-item">
                        <div className="panel-item-label">Is this account professionally managed? :</div>
                        <div className="panel-item-value">{props.data.professionallyManaged}</div>
                    </div>

                    {props.data.attachment && 
                    <div className="panel-item">
                        <div className="panel-item-label">Attachment Document :</div>
                        <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                    </div>
                    }

                    {props.data.submittedForLabel &&
                        <div className="panel-item">
                            <div className="panel-item-label">Submit On Behalf of :</div>
                            <div className="panel-item-value">{props.data.submittedForLabel}</div>
                        </div>
                    }
                        
                </div>

                </div>

            <CommentComp data={props.data.comments} />
            {isLevelFourRaymondJames() && props.mode && <ChangeSetDisplayComp changeSet={props.data.changeSet} />}
        </div>
    );
}

export default UserAccountDetailComp;